module.exports = __webpack_public_path__ + "static/media/balanceQuestion.484d742d.mp3";